import Styles from './MobilePushToApp.module.scss'
import { detectPlatform } from 'utils/workspaceUtils'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Email } from 'blaze-ui/icons/24'
import { UserClient } from 'api/clients/UserClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'

export const MobilePushToApp = ({
  isMidFlow = false,
  publishDay = '',
  desktopPath = '',
  onContinue = () => {},
}: {
  isMidFlow?: boolean
  publishDay?: string
  desktopPath?: string
  onContinue?: () => void
}) => {
  const platform = detectPlatform()
  const isIOS = platform === 'ios'

  const sendDesktopLinkEmail = () => {
    UserClient.sendAutopilotDesktopLinkEmail(desktopPath)
    showToastMessage('Email sent!')
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.cta}>
        <div className={Styles.text}>
          {isMidFlow && (
            <>
              <h1 className={Styles.title}>Your Brand Kit is ready! For the best experience, use the app or desktop</h1>
              <Text>
                You can create and manage content at blaze.ai on desktop. Mobile browsers are supported, but the
                experience isn’t fully optimized yet.
              </Text>
            </>
          )}
          {!isMidFlow && (
            <>
              <h1 className={Styles.title}>Your posts are ready! Open the app or desktop to view them</h1>
              <Text>
                Your posts will start publishing on <strong>{publishDay}</strong> if you connected your accounts.{' '}
                {isIOS ? 'Use the iOS app or' : 'Go to'} blaze.ai on desktop to review and edit.
              </Text>
            </>
          )}
        </div>
        <div className={Styles.buttons}>
          {isIOS && (
            <>
              <ButtonLink size="lg" fullWidth to="https://apps.apple.com/us/app/blaze-ai/id6736776805">
                Download Blaze iOS App
              </ButtonLink>
              <Button size="lg" fullWidth frontIcon={Email} variant="tertiary" onPress={sendDesktopLinkEmail}>
                Email me the Desktop Link
              </Button>
            </>
          )}
          {!isIOS && (
            <>
              <Button size="lg" fullWidth frontIcon={Email} onPress={sendDesktopLinkEmail}>
                Email me the Desktop Link
              </Button>
            </>
          )}
          {isMidFlow && (
            <Button size="lg" fullWidth variant="tertiary" onPress={onContinue}>
              Keep Going On Web (Not Optimized)
            </Button>
          )}
        </div>
      </div>
      <div className={Styles.graphic}>
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1757641051/onboarding_assets/mobile_push_to_app_upgoxj.png"
          alt="Mobile App"
        />
      </div>
    </div>
  )
}
